/*******************************************************************************
 * Project：WDCK
 * Summary:
 *　　 Reset password function
 * History：
 *      AnBD            2021/08/31    Create new
******************************************************************************/
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store, StoreRootModule } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { SrcExamResetPassword } from '../src-pw-reset/src-pw-reset.service';
import { LoadingService } from '../../../../layout/loading/loading.service';
import { DialogModalService } from '../../../../shared/dialog-modal/dialog-modal.service';
import { Utility } from '../../../../shared/utility/utility';
import { UserLoginInfoDto } from '../../../../models/UserLoginInfoDto';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { QueryParams } from 'src/app/shared/constant';

@Component({
  selector: 'app-src-pw-reset',
  templateUrl: './src-pw-reset.component.html',
  styleUrls: ['./src-pw-reset.component.scss']
})
export class SrcPwResetComponent implements OnInit, OnDestroy {

  @Output() closeModal = new EventEmitter<void>();
  maillAdress: string;
  PassReissueKey: string;
  passWord = '';
  confirmPassword = '';
  rsData: any;
  clicked = false;
  ngUnsubscribe = new Subject();
  strErrFomart: string;
  strErrFomart2: string;
  isErrFomart = false;
  isErrFomart2 = false;
  strErrNotSame: string;
  isErrNotSame = false;
  LocalMail: any;
  reqPatern = false;
  reqPatern2 = false;
  constructor(
    private modalService: NgbModal,
    private auth: SrcExamResetPassword,
    private loadingSrv: LoadingService,
    public util: Utility,
    private dialogModalService: DialogModalService,
    private translate: TranslateService,
    private router: Router,
    private routeActived: ActivatedRoute
  ) {
  }
  ngOnDestroy(): void {
    this.util.resetZoomBrowser();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit(): void {
    this.util.addPerfectScrollBar();
    this.maillAdress = this.routeActived.snapshot.queryParams[QueryParams.Mail];
    this.PassReissueKey = this.routeActived.snapshot.queryParams[QueryParams.PReissueKey];
    this.CheckTime();
  }
  CheckTime() {
    this.loadingSrv.setDisplay(true);
    const sLoginData = new UserLoginInfoDto();
    sLoginData.MailAdress = this.maillAdress;
    sLoginData.PassReissueKey = this.PassReissueKey;
    this.auth.CheckTime(sLoginData).subscribe(async data => {
      this.loadingSrv.setDisplay(false);
      if (data === 'B') {
        const cnf = await this.dialogModalService.openErrorModal
          (this.translate.instant('MESS_URL_CANNOT_ACCESS_PLS_RESTART')).toPromise();
        if (cnf.buttonName === 'ok') {
          this.router.navigateByUrl('toppage');
        }
      }
      if (data === 'A') {
        const cnf = await this.dialogModalService.openErrorModal
          (this.translate.instant('MESS_ENABLE_TIME_OFLINK_HAS_EXPIRED')).toPromise();
        if (cnf.buttonName === 'ok') {
          this.router.navigateByUrl('src-pw-forgot');
        }
      }
    }, err => {
      this.loadingSrv.setDisplay(false);
    });
  }
  validateRequire() {
    let isValidate = false;
    if (this.util.isNullOrEmpty(this.passWord)) {
      this.strErrFomart = this.translate.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED').replace('{0}', this.translate.instant('STR_NEW_PASSWORD'));
      this.isErrFomart = true;
      isValidate = true;
    } else {
      this.isErrFomart = false;
    }
    if (this.util.isNullOrEmpty(this.confirmPassword)) {
      this.strErrFomart2 = this.translate.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED').replace('{0}', this.translate.instant('STR_CONFIRM_PASSWORD'));
      this.isErrFomart2 = true;
      isValidate = true;
    }
    else {
      this.isErrFomart2 = false;
    }
    return isValidate;
  }
  inputValidate() {
    const patern = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.]{8,16}$/);
    if (this.passWord.length < 8) {
      this.strErrFomart = this.translate.instant('MESS_CMN_ERR_OVER_MIN_LENGTH').replace('{0}', this.translate.instant('STR_NEW_PASSWORD'))
        .replace('{1}', this.translate.instant('8'));
      this.isErrFomart = true;
      return true;
    } else {
      this.isErrFomart = false;
    }
    this.reqPatern = !patern.test(this.passWord);
    if (this.reqPatern) {
      this.strErrFomart = 'MESS_ERR_WRONG_PW_FORMAT';
      this.isErrFomart = true;
      return true;
    } else {
      this.isErrFomart = false;
    }
    if (this.confirmPassword !== this.passWord) {
      this.isErrFomart2 = true;
      this.strErrFomart2 = 'MESS_ERR_NEW_PW_NOT_SAME';
      return true;
    }
    else {
      this.isErrFomart2 = false;
    }
    return false;
  }
  async Reset() {
    if (this.validateRequire()) {
      return;
    }
    if (this.inputValidate()) {
      return;
    }
    this.loadingSrv.setDisplay(true);
    const sLoginData = new UserLoginInfoDto();
    sLoginData.NewPassword = window.btoa(this.passWord);
    sLoginData.Url = window.location.href;
    sLoginData.ConfirmPassword = window.btoa(this.confirmPassword);
    sLoginData.MailAdress = this.maillAdress;
    sLoginData.PassReissueKey = this.PassReissueKey;
    this.auth.Reset(sLoginData).pipe(
      finalize(() => {
        this.loadingSrv.setDisplay(false);
      })
    ).subscribe(data => this.rsData = data, (error) => {
    }, async () => {
      if (this.rsData.Err === 'T') {
        this.dialogModalService.openSuccessModal(this.translate.instant('MESS_CMN_INF_REGIS_SUCCESS'));
        this.isErrFomart = false;
        this.isErrFomart2 = false;
        const saveInfo: any = {};
        const loginData = this.rsData.Data;
        saveInfo.UserID = loginData.UserID?.trim();
        saveInfo.MailAdress = loginData.MailAdress?.trim();
        saveInfo.Name = loginData.Name?.trim();
        saveInfo.KanaName = loginData.KanaName?.trim();
        saveInfo.DateOfBirth = loginData.DateOfBirth?.trim();
        saveInfo.Gender = loginData.Gender.trim();
        saveInfo.PhoneNum = loginData.PhoneNum?.trim();
        saveInfo.PostalCode = loginData.PostalCode?.trim();
        saveInfo.Adress1 = loginData.Adress1?.trim();
        saveInfo.Adress2 = loginData.Adress2?.trim();
        saveInfo.RegistrationDiv = loginData.RegistrationDiv?.trim();
        saveInfo.CountryCode = loginData.CountryCode?.trim();
        localStorage.removeItem('ExamineauthorizationData');
        localStorage.ExamineauthorizationData = JSON.stringify(saveInfo);
        localStorage.fLogin = 'true';
        const HtOrgCode = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
        if (this.util.isNullOrEmpty(HtOrgCode)){
          this.router.navigateByUrl('toppage');
        }else{
          this.router.navigate(['insurance-sel'], {
            queryParams: {
              htorgcode: HtOrgCode
            }
          });
        }
      }
      else if (this.rsData.Err === 'F') {
        this.isErrFomart = false;
        this.isErrFomart2 = true;
        this.dialogModalService.openErrorModal(this.translate.instant('MESS_ERR_REGIS_FAILED'));
      }
    });
  }
  onModalClose(): void {
    this.closeModal.emit();
  }
  removeErr(event: any, id: number) {
    if (event.which === 32) {
      event.preventDefault();
    }
    if (id === 1) {
      this.isErrFomart = false;
    }
    if (id === 2) {
      this.isErrFomart2 = false;
    }
  }
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
  }
}
